<!-- 定向询价 enquiryType: 0 Enquiry/querySupplierOfferList-->
<template>
  <div>
    <div class="container">
      <Search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        :btn-hidden="false"
        :count="100"
        @handleFilter="handleSearch"
        @handleReset="handleClear"
      ></Search>
    </div>

    <div class="container">
      <div class="handle-wrapper" v-if="query.offerOrNot === 1">
        <eui-btn @click="handleExport">导出报价单信息</eui-btn>
      </div>
      <TableList
        :loading="tableLoading"
        :table-data="tableData"
        :table-label="tableLabel"
        index-show
      >
        <template #createSource="{ scope }">
          <div>{{ createSourceTypeObj[scope.row.createSource] }}</div>
        </template>
        <template #purchaseCompany="{ scope }">
          <div class="purchaseCompany">{{ scope.row.purchaseCompany }}</div>
          <eui-btn type="link" font-size="12px" @click="openMessage(scope.row)">
            <div style="display: flex; align-items: center">
              <img :src="messageImg" />发送留言
            </div>
          </eui-btn>
        </template>
        <template #endTime="{ scope }">
          <div class="stop-time">
            <count-down
              v-if="scope.row.quotationDeadline"
              :stop-time="scope.row.quotationDeadline"
            ></count-down>
            <span style="color: #e8efff" v-else>0天0小时0分0秒</span>
          </div>
        </template>
        <!-- 操作 -->
        <template #operation="{ scope }">
          <eui-btn
            v-if="
              (scope.row.enquiryStatus === 3 ||
                scope.row.enquiryStatus === 2 ||
                scope.row.enquiryStatus === 16) &&
              scope.row.quotationCount === 0
            "
            type="link"
            font-size="12px"
            @click="handleViewOffer(scope.row)"
          >
            报价
          </eui-btn>
        </template>
        <!-- 弹框 -->
      </TableList>
      <div class="pagination">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="listQuery.pageNum"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="listQuery.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </div>
    </div>
    <MessageBoard
      :visible="messageVisible"
      :set-visible="setVisible"
      :current="current"
      :content="content"
    />
    <!-- 延时弹窗 -->
    <!--
      
      title="报价有效期时间延时"
      :visible.sync="delayVisible"
      width="600px"
      :before-close="handleClose"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="set-price"
      -->
    <e-dialog
      dialog-title="报价有效期时间延时"
      dialog-type=""
      :center-dialog-visible="delayVisible"
      :popup-width="'450px'"
      :show-close="false"
      @submitPopupData="handleDelay"
      @updateVisible="delayVisible = false"
      @resetPopupData="delayVisible = false"
    >
      <div class="">
        <el-form
          ref="delayForm"
          :model="delayForm"
          :rules="delayRules"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item label="询价单名称：" prop="name">
            <span>{{ paramsRow.enquiryName }}</span>
          </el-form-item>
          <!-- :picker-options="quotationDeadlineTimeDate" -->
          <el-form-item label="报价有效期时间：" prop="quotationDeadline">
            <el-date-picker
              v-model="delayForm.quotationDeadline"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH"
              value-format="timestamp"
              default-time="16:00:00"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="延时原因：" prop="remark">
            <el-input
              v-model="delayForm.remark"
              type="textarea"
              maxlength="300"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </e-dialog>

    <e-dialog
      dialog-title="提示"
      :dialog-type="''"
      :center-dialog-visible="dialogVisible"
      :popup-width="'450px'"
      :show-close="false"
      button-tip="前往"
      @submitPopupData="goEC"
      @updateVisible="handleECClose"
      @resetPopupData="handleECClose"
    >
      <div>
        您将离开易派客平台，进入到{{
          current.createSource === 1 ? '盐湖' : '石化EC'
        }}系统{{ ecStr }}，是否前往？
      </div>
    </e-dialog>

    <e-dialog
      dialog-title="提示"
      :dialog-type="''"
      :center-dialog-visible="blackVisible"
      :popup-width="'450px'"
      :show-close="false"
      @updateVisible="handleBlackClose"
      @resetPopupData="handleBlackClose"
      @submitPopupData="handleSubmitClose"
    >
      <div>{{ tipContent }}</div>
    </e-dialog>
    <!-- 协议 弹框-->
    <quotation-notice-dialog
      protocolType="supplier"
      :quotationNoticeVisible="quotationNoticeVisible"
      :rateNum="rateNum"
      v-if="quotationNoticeVisible"
      @closeDialog="handleCloseDialog"
      @handleConfirm="handleConfirm"
    />

    <!-- 询价前置弹框-->
    <tip-dialog
      v-if="tipVisible"
      :tip-visible="tipVisible"
      :is-tree-tip="isTreeTip"
      @closeEnquiryDialog="closeEnquiryDialog"
      :is-price="isPrice"
    />
  </div>
</template>

<script>
import quotationNoticeDialog from '../../../../components/protocolPopup/quotationNoticeDialog';
import eDialog from '@/components/common/e-dialog.vue';
import TableList from '@/modules/projectA/components/common/e-table-list';
import Search from '@/modules/projectA/components/common/e-search';
import api from '@/modules/projectA/api/order';
import utils from '@/modules/projectA/utils/utils';
import MessageBoard from '@/modules/projectA/components/messageBoard';
import Api from '@/modules/projectA/api/enquiry';
import userApi from '@/modules/projectA/api/user';
import rateValidate from '@/modules/projectA/components/enquiry/rateValidate';
import countDown from '../countDown';
import { callBackUrl } from '@/modules/projectA/api/config';
import enquiryMixin from '@/modules/projectA/components/enquiry/enquiryMixin';
import hideCompanyMixin from '@/modules/projectA/components/enquiry/hideCompanyMixin';

const createSourceTypeObj = {
  0: '平台询价',
  1: '平台询价',
  2: '石化询价',
  7: '合金不锈专区',
};
export default {
  components: {
    TableList,
    Search,
    MessageBoard,
    eDialog,
    countDown,
    quotationNoticeDialog,
  },
  mixins: [enquiryMixin, hideCompanyMixin],
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
    back: String,
  },
  data() {
    return {
      rateNum: 0,
      showOnlineFlag: true,
      tipContent: '', //点对点 和 平台 被 拉黑的 提示
      confirmProtocol: false, //是否确认协议
      quotationNoticeVisible: false,
      confirmFlag: false,
      blackVisible: false,
      blackInfo: {},

      ecStr: '',
      dialogVisible: false,
      createSourceTypeObj,
      messageImg: require('@/assets/img/messageBoard/message.svg'),
      messageVisible: false,
      current: {},
      btnLoading: false,
      delayVisible: false,
      delayForm: { remark: '', quotationDeadline: '' },
      delayRules: {
        /* quotationDeadline: [
          { required: true, message: '请选择时间', trigger: 'change' }
        ] */
      },
      quotationDeadlineTimeDate: {
        disabledDate: (time) => {
          const beginTime = this.paramsRow.quotationValidity;
          console.log(beginTime, 'beginTime');
          if (beginTime) {
            return (
              time.getTime() <
                new Date(beginTime).getTime() +
                  1 *
                    ((24 - new Date(beginTime).getHours()) * 60 * 60 * 1000) ||
              time.getTime() >
                new Date(beginTime).getTime() + 15 * (24 * 60 * 60 * 1000)
            );
          }
        },
      },
      paramsRow: {},
      directionalLength: '',
      allLength: '',
      waitLength: '',
      publicFlag: false,

      // 有时间的不要给默认值了
      listQuery: {
        quotationDeadlineStart: null,
        quotationDeadlineEnd: null,
        purchaseCompany: null,
        enquiryName: null,
        enquiryNo: null,
        offerStatus: null,
        pageNum: 1,
        pageSize: 10,
        isDoC: null,
        shipmentType: null,
        enquirySource: null,
        enquiryCategory: null,
        createMemberName: null,
        createModeList: [0, 1, 2, 3, 4, 5],
      },
      total: 0,
      cloneListQuery: {},

      fieldList: [
        { label: '询价企业', type: 'input', value: 'purchaseCompany' },
        { label: '询价单名称', type: 'input', value: 'enquiryName' },
        { label: '询价单编号', type: 'input', value: 'enquiryNo' },
        { label: '询价人', type: 'input', value: 'createMemberName' },
        /* {
          label: '报价状态',
          type: 'select',
          value: 'offerStatus',
          list: 'queryAfterSaleType',
          clearable: true,
          itemHidden: false,
        }, */
        {
          label: '结算方式',
          type: 'select',
          value: 'isDoC',
          list: 'isDoCOptions',
          clearable: true,
        },
        {
          label: '配送方式',
          type: 'select',
          value: 'shipmentType',
          list: 'shipmentTypeOptions',
          clearable: true,
        },
        {
          label: '询价来源',
          type: 'select',
          value: 'enquirySource',
          list: 'enquirySourceOptions',
          clearable: true,
        },
        {
          label: '询价分类',
          type: 'select',
          value: 'enquiryCategory',
          list: 'enquiryCategoryOptions',
          clearable: true,
        },
        {
          label: '报价截止时间',
          type: 'date',
          value: 'createTime',
          dateType: 'datetimerange',
          defaultTime: ['00:00:00', '23:59:59'],
          clearable: true,
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
        },
      ],
      listTypeInfo: {
        queryAfterSaleType: [
          { name: '全部', id: null },
          /* { name: '待报价', id: 0 }, */
          { name: '已报价', id: 1 },
          { name: '已入选', id: 2 },
          { name: '未入选', id: 3 },
          { name: '磋商中', id: 6 },
        ],
        isDoCOptions: [
          { name: '全部', id: null },
          { name: '款到发货', id: 0 },
          { name: '货到付款', id: 1 },
        ],
        shipmentTypeOptions: [
          { name: '全部', id: null },
          { name: '卖家自行配送', id: 1 },
          /* { name: '自提', id: 2 }, */
          { name: '第三方物流', id: 3 },
        ],
        enquirySourceOptions: [
          { name: '全部', id: null },
          { name: '平台询价', id: 0 },
          { name: '石化询价', id: 1 },
          { name: '合金不锈专区', id: 2 },
        ],
        enquiryCategoryOptions: [
          { name: '商品', id: 2 },
          { name: '物流询价', id: 1 },
        ],
      },

      tableData: [],
      // queryEnquiryPage
      tableLabel: [
        {
          label: '询价单名称',
          param: 'enquiryName',
          align: 'center',
          minWidth: '180',
        },
        {
          label: '询价单编号',
          param: 'enquiryNo',
          align: 'center',
          minWidth: '160',
        },
        {
          label: '询价企业',
          slot: 'purchaseCompany',
          align: 'center',
          minWidth: '280',
        },
        /* {
          label: '询价单状态',
          param: 'offerStatus',
          align: 'center',
          render: (row) => {
            const obj = {
              0: '待报价',
              1: '已报价',
              2: '已入选',
              3: '未入选',
              4: '询价过期',
              5: '询价作废',
              6: '磋商中',
            };

            return obj[row.offerStatus];
          },
        }, */
        {
          label: '询价来源',
          slot: 'createSource',
          align: 'center',
          minWidth: '120',
        },
        //         createSourceList (5,6) 物流
        // createSourceList (0,1,2,3,4,7) 商品
        {
          label: '询价分类',
          param: 'createSource',
          align: 'center',
          minWidth: '120',
          render: (row) => {
            const obj = {
              5: '物流询价',
              6: '物流询价',
            };
            return obj[row.createSource] ? obj[row.createSource] : '商品';
          },
        },
        {
          label: '结算方式',
          param: 'isDoC',
          align: 'center',
          render: (row) => {
            const obj = {
              0: '款到发货',
              1: '货到付款',
            };

            return obj[row.isDoC];
          },
        },
        {
          label: '配送方式',
          align: 'center',
          render: (row) => {
            const obj = {
              1: '卖家自行配送',
              3: '第三方物流',
            };

            return obj[row.shipmentType];
          },
          minWidth: '120',
        },
        {
          label: '询价人',
          param: 'realName',
          align: 'center',
        },
        {
          label: '报价开始时间',
          param: 'releaseTime',
          align: 'center',
          minWidth: '150',
        },
        {
          label: '报价截止时间',
          param: 'quotationDeadline',
          align: 'center',
          minWidth: '150',
        },
        {
          label: '距结束',
          param: 'quotationDeadline',
          align: 'center',
          minWidth: '150',
          slot: 'endTime',
        },
        {
          label: '操作',
          width: '200',
          fixed: 'right',
          align: 'center',
          slot: 'operation',
        },
      ],
      content: '',
      tableLoading: false,
    };
  },
  computed: {
    cancellationTitle() {
      // directional 定向
      return this.tabEnquiryType === 'directional'
        ? '您的操作将作废报价单据，这条单据下所有报价信息均将认作失效，此操作无法恢复，是否继续？'
        : '您的操作将作废报价单据，这条单据下所有报价信息均将认作失效，此操作无法恢复，是否继续？';
    },
  },

  created() {
    this.cloneListQuery = this.$options.data().listQuery;
    // 处理 查询 和 列表不同
    const { offerOrNot = -1 } = this.query;
    // 定向公开列表与搜索一样 不需要处理
    // 已报价的 搜索多询价状态 列表多报价状态少报价时间
    if (offerOrNot === 1) {
      this.tableLabel.splice(this.tableLabel.length - 2, 1);
      this.tableLabel.splice(2, 0, {
        label: '询价单状态',
        param: 'offerStatus',
        align: 'center',
        render: (row) => {
          const obj = {
            /*  0: '待报价', */
            1: '已报价',
            2: '已入选',
            3: '未入选',
            4: '询价过期',
            5: '询价作废',
            6: '磋商中',
          };

          return obj[row.offerStatus];
        },
      });
      if (this.$store.state.USERINFO.identity != 'purchase') {
        const arr = [
          { name: '询价作废', id: 5 },
          { name: '询价过期', id: 4 },
        ];
        this.listTypeInfo.queryAfterSaleType =
          this.listTypeInfo.queryAfterSaleType.concat(arr);
      }
      this.fieldList.splice(4, 0, {
        label: '报价状态',
        type: 'select',
        value: 'offerStatus',
        list: 'queryAfterSaleType',
        clearable: true,
        itemHidden: false,
      });
    }
    this.getList(this.listQuery);
  },
  activated() {
    this.getList(this.listQuery);
  },
  methods: {
    handleDelete(row) {
      // removeOffer
      this.$confirm('您正在执行删除操作，删除后无法恢复，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          Api.removeOffer({ supplierOfferId: row.supplierOfferId }).then(
            (result) => {
              if (result.code === '200') {
                this.$message({
                  type: 'success',
                  message: '删除成功!',
                });
                this.getList(this.listQuery);
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    // 导出
    handleExport: _.debounce(async function () {
      const result = await api.exportOfferInfo({
        ...this.listQuery,
        createSource: null,
      });
      if (result?.code === '500') {
        return;
      }
      if (result.type == 'application/json') {
        utils.fileExportResponseError(result);
      } else {
        const time = utils.formatDate(new Date(), 'yyyyMMdd');
        utils.downFile(result, `报价单信息${time}`);
      }
    }),
    handleBlackClose() {
      this.blackVisible = false;
    },
    handleSubmitClose() {
      this.blackVisible = false;
      if (this.toJump) {
        const url = `${callBackUrl}/paymentAccount`;
        window.open(url, '_blank');
      }
    },
    handleECClose() {
      this.dialogVisible = false;
    },
    goEC() {
      this.dialogVisible = false;
      const url =
        this.current.offerStatus !== 0
          ? this.current.offerExternalUrl
          : this.current.enquiryExternalUrl;
      window.open(url, '_blank');
    },
    setVisible(bool) {
      this.messageVisible = bool;
    },
    openMessage(row) {
      const { purchaseCompany, purchaseCompanyId } = row;
      this.content = `询价单名称：${row.enquiryName};询价单编号:${row.enquiryNo};`;
      this.current = {
        ...row,
        replyCompanyName: purchaseCompany,
        replyCompanyId: purchaseCompanyId,
      };
      this.messageVisible = true;
    },
    // 作废 弹窗操作
    async handleCancellation(row) {
      this.$confirm(this.cancellationTitle, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          await api
            .cancelSupplierOffer({ supplierOfferId: row.supplierOfferId })
            .then((res) => {
              if (res.code === '200') {
                this.getList(this.listQuery);
              }
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    openDelayDia(row) {
      this.delayVisible = true;
      this.paramsRow = { ...row };
    },

    // 延时操作
    handleDelay() {
      this.$refs.delayForm.validate(async (valid) => {
        if (valid) {
          const params = {
            remark: this.delayForm.remark,
            supplierOfferId: this.paramsRow.supplierOfferId,
            newSupplierOfferChangeDataAO: {
              quotationValidity: this.delayForm.quotationDeadline,
            },
          };
          const result = await api.changeSupplierOfferDelay(params);
          if (result.code === '200') {
            this.getList(this.listQuery);
            this.delayVisible = false;
          }
        } else {
          return false;
        }
      });
    },

    handleConfirm() {
      this.quotationNoticeVisible = false;
      this.confirmFlag = true;
    },
    handleCloseDialog() {
      this.quotationNoticeVisible = false;
    },
    fn() {
      /* // 备案登记配置
        const baRateRes = await userApi.queryInquiryRate({
          companyId: row.purchaseCompanyId,
        });
        //先校验备案 在校验平台 一企一面
        if (baRateRes.success && baRateRes.data) {
          //   备案得两个费率和    customRate:客户引入方/备案方比例，小数 ;  platformRate:平台方比例，小数
          let baAllRate = baRateRes.data
            ? Number(baRateRes.data.customRate) +
              Number(baRateRes.data.platformRate)
            : 0;
          this.rateNum = baAllRate;
          console.log('有备案情况 => 一企一面rateNum:', this.rateNum, '%0')
          if (baAllRate > 0) {
            //备案有值 有弹框；
            this.showOnlineFlag = true;
          } else {
            //是 0  不校验 弹框
            this.showOnlineFlag = false;
          }
        } else {
          //无备案，校验平台
          //平台配置
          const ptRateRes = await filingApi.queryConfigList([
            'chargeNotice.enquiryServiceRate',
          ]);
          this.rateNum =
            ptRateRes.data && ptRateRes.data.length > 0
              ? Number(ptRateRes.data[0].configValue) * 10
              : 0;

          console.log('无备案的情况-展示平台rateNum:', this.rateNum, '*10 + %0 后')

          if (ptRateRes.success && Number(ptRateRes.data[0].configValue) > 0) {
            this.showOnlineFlag = true;
          } else {
            this.showOnlineFlag = false;
          }
        } */
    },
    async handleViewOffer(row) {
      if (row.createSource && ![0, 7].includes(row.createSource)) {
        this.ecStr = '参与报价';
        this.current = row;
        const url = row.externalUrl;
        window.open(url, '_blank');
        return;
      }

      /* 
        1.只校验平台的单子
        1.1.是否开通易专采, 如果没开通, 弹窗提示跳转到开通页面
        1.2.是否配置组织架构, 如果没有配置, 跳转到配置页面去配置

        20250928迭代去掉 组织架构和一企一面 只去掉报价的, 询价保留
       */
      /* const enFlag = await this.handleEnquiry('报价');
      if (!enFlag) return; */

      /* 
        2.校验是否是规定的5加公司, 如果是则不展示费率, 不校验是否开通在线支付
        this.isHiddenAgreement 为 true 则表示 是那5家公司
      */
      this.isHiddenAgreement = await this.hideCompaniesByIdFn(
        row.purchaseCompanyId
      );

      // 当前时间小于报价开始时间 弹提示
      if (row.releaseTime && this.compareDate(row.releaseTime)) {
        this.$message.warning('询价还未开始，请在询价开始时间后参与报价。');
      } else {
        //华东小程序 只判断开始时间 其他不判断
        if (row.createSource == 7) {
          this.$router.push({
            path: '/huadongSeeDetails',
            query: { type: 'offer', ...row, back: this.back },
          });
          return false;
        }

        /* 
          showOnlineFlag 是否展示费率协议
          rateNum 费率具体值
        */
        const { showOnlineFlag, rateNum } = await rateValidate(
          row.purchaseCompanyId
        );

        this.rateNum = rateNum;
        const { companyId = '' } = this.$store.state.USERINFO || {};
        // 5家肯定不展示在线支付
        if (!this.isHiddenAgreement) {
          // if (showOnlineFlag) {
          /* 
            是否开通在线支付
              费率必须大于 0 才校验 
            费率弹窗是 
              不管费率是否大于0都展示, 只要有就行
              先校验如果备案费率有, 不管费率是否大于0都展示服务协议 直接取备案费率
              如果没备案 就校验平台费率 也是同样的 不管费率是否大于0都展示服务协议
          */
          if (this.rateNum > 0) {
            // 校验是否在线支付
            const resOnline = await userApi.batchJudgeOnlinePayment({
              companyIdList: [companyId],
            });
            if (
              resOnline.success &&
              resOnline.data[0]?.result?.auth !== '已认证'
            ) {
              this.tipContent =
                '未开通在线支付暂无法参与报价，是否前往开通在线支付？';
              // 弹窗提示
              this.blackVisible = true;
              this.toJump = true;
              return false;
            }
          }
        }

        const { purchaseCompanyId } = row;
        const result = await api.blackCheck({
          inquiryCompanyId: purchaseCompanyId,
          companyId: companyId,
        });
        // 平台校验黑名单
        const resCheck = await api.blacklistCheck({
          businessDirection: 'supplier',
          companyId: companyId,
          serviceType: 1,
        });

        if (result.success && resCheck.success) {
          if (result.data.existFlag || resCheck.data.existFlag) {
            if (result.data.existFlag) {
              // 点对点 被正在报价的企业限制了
              this.blackInfo = { ...result.data };
              this.tipContent = `您已被限制对该企业询比价报价，如有疑问，请联系管家${this.blackInfo.purchaseButlerMobile}。`;
            } else if (resCheck.data.existFlag) {
              // 平台 被平台限制了
              this.tipContent = `您已被限制对平台询价单报价，如有疑问，请联系平台运营${resCheck.data.contactsMobile}。`;
            }
            // 弹窗提示
            this.blackVisible = true;
            this.toJump = false;
          } else {
            console.log(row.createTime, 'row.createEnquiryTime');
            const createTime = new Date(row.createTime);
            createTime.setHours(0, 0, 0, 0);
            let targetDate = Object;
            if (process.env.NODE_ENV === 'production') {
              targetDate = new Date(2023, 10, 8); //月份减1
            } else {
              targetDate = new Date(2023, 9, 20); //月份减1
            }
            targetDate.setHours(0, 0, 0, 0);

            if (!this.isHiddenAgreement) {
              // 2023年11.9日才开始弹框   协议弹框提示
              if (
                !this.confirmFlag &&
                showOnlineFlag &&
                targetDate.getTime() < createTime.getTime()
              ) {
                this.quotationNoticeVisible = true;
                return false;
              }
            }

            this.$router.push({
              path: '/seeDetails',
              query: { type: 'offer', ...row, back: this.back },
            });
          }
        }
      }
    },

    // 时间比较
    compareDate(d1) {
      const date1 = new Date(Date.parse(d1));
      const now = new Date();
      // 当前时间小于报价开始时间
      return date1 > now;
    },

    // 触发搜索按钮
    handleSearch(val) {
      const createSourceListType = {
        1: [5, 6],
        2: [0, 1, 2, 3, 4, 7],
      };
      if (val.createTime) {
        val.quotationDeadlineStart = val.createTime[0];
        val.quotationDeadlineEnd = val.createTime[1];
      } else {
        val.quotationDeadlineStart = null;
        val.quotationDeadlineEnd = null;
      }
      // val.createSourceList = !Number.isInteger(val.createSource)
      //   ? null
      //   : val?.createSource === 0
      //   ? [0, 1]
      //   : [2];

      console.log(val, '搜索参数');
      this.listQuery = { ...val };
      this.getList(this.listQuery);
    },

    // 触发重置
    handleClear(val) {
      console.log(val, '重置参数');
      this.listQuery = { ...this.cloneListQuery };
      // this.listQuery = { ...val };
      this.getList(this.listQuery);
    },

    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },

    handleSizeChange(size) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = size;
      this.getList(this.listQuery);
    },

    async getList(params) {
      try {
        Object.assign(params, this.query);
        this.tableLoading = true;
        const result = await Api.queryEnquiryPage(params);
        if (result.code === '200') {
          this.tableData = result.data.records;
          this.total = result.data.total;
        }
      } finally {
        this.tableLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* .purchaseCompany {
  margin: 20px 0 14px 0;
} */

.message {
  display: flex;
  align-items: center;
  color: rgb(0, 100, 200);
  cursor: pointer;
  justify-content: center;
  margin-bottom: 10px;

  img {
    width: 18px;
    margin-right: 6px;
  }
}

::v-deep .el-textarea__inner {
  border-radius: 0;
}

.stop-time {
  color: #f0250f;
}
</style>
